import { ICReportWidget } from '@/pages/funds/ic-report/components/ICReportWidget'
import { DownloadRawDataButtons } from '@/pages/funds/ic-report/components/composites/scenario-analysis-buttons'
import { FundLevelScenarioChart as FundLevelScenarioChartNew } from '@/pages/funds/ic-report/components/primitives/charts/FundLevelScenarioChartNew'
import { BaseICReportPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { labels } from '@/pages/funds/ic-report/constants'
import { fundLevel } from '@/react-query/queries/ic-report/hooks'

export type FundLevelScenarioProps = BaseICReportPrimitive & {}

export const FundLevelScenario: React.FC<FundLevelScenarioProps> = () => {
  return (
    <div className="flex items-stretch gap-4">
      {/* <ICReportWidget
        widget={{
          component: FundLevelScenarioChart,
          query: fundLevel.useHistoricalEvents,
          key: 'fund_level.historical_events',
          labels: labels.fund_level.scenario_analysis,
          sidebarTitle: 'sdfsdf',
        }}
      /> */}
      <ICReportWidget
        widgetButtons={[
          <DownloadRawDataButtons
            filePrefix={`fund_level`}
            query={fundLevel.useHistoricalEventsNew}
          />,
        ]}
        widget={{
          component: FundLevelScenarioChartNew,
          query: fundLevel.useHistoricalEventsNew,
          key: 'fund_level.historical_events',
          labels: labels.fund_level.scenario_analysis,
          sidebarTitle: 'sdfsdf',
        }}
      />
    </div>
  )
}
